import type { ModelPrice } from "@/services/adminModelCurrency";
import { formatPrice } from "./helpers";

/** One muted line with what a model costs, or that we don't know yet. */
const PriceLine = ({ price }: { price: ModelPrice | null | undefined }) => (
  <p className="text-xs text-muted-foreground">{formatPrice(price)}</p>
);

export default PriceLine;
